// URLのハッシュ(#スラッグ)に該当する質問までスクロールし、アコーディオンを開く
$(function () {
    var hash = window.location.hash;
    if (!hash) {
        return;
    }

    var id = decodeURIComponent(hash.substring(1));
    var target = document.getElementById(id);
    if (!target) {
        return;
    }

    var $target = $(target);

    // 親カテゴリーのアコーディオンを開く(カテゴリー内の質問の場合)
    $target.parents('.accordion li').each(function () {
        $(this).children('ul').show();
        $(this).children('a.accordion-title').addClass('active');
    });

    // 対象質問の回答を開く
    $target.children('ul').show();
    $target.children('a.accordion-title').addClass('active');

    // 固定ヘッダー分のオフセットを引いてスクロール(SPはヘッダーが低いため小さめ)
    var headerOffset = window.matchMedia('(max-width: 767px)').matches ? 70 : 120;
    $('html, body').animate({
        scrollTop: $target.offset().top - headerOffset
    }, 500);
});
